import type { SearchEngineDto } from '../api/types.js';

/** Web search URL for a given engine + query. */
export function webUrlFor(engine: SearchEngineDto, query: string): string {
  const q = encodeURIComponent(query);
  if (engine === 'kiddle') return `https://www.kiddle.co/s.php?q=${q}`;
  if (engine === 'google') return `https://www.google.com/search?q=${q}`;
  return `https://www.bing.com/search?q=${q}`;
}

/** YouTube search URL for a query. */
export function youtubeUrlFor(query: string): string {
  return `https://www.youtube.com/results?search_query=${encodeURIComponent(query)}`;
}

/**
 * Reconstruct the URL for a recorded search so the day-review can re-run it.
 * `engine` is free text from the log (kiddle/google/bing for web; youtube for
 * video); unknown web engines fall back to Kiddle (the kid-safe default).
 */
export function searchUrlFor(kind: 'web' | 'youtube', engine: string, query: string): string {
  if (kind === 'youtube') return youtubeUrlFor(query);
  const known: SearchEngineDto = engine === 'google' || engine === 'bing' ? engine : 'kiddle';
  return webUrlFor(known, query);
}
